import { UPLOAD_PHOTO_SUCCESS } from './actions'

const initialState = {
  imgUrl: ''
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_PHOTO_SUCCESS: {
      return {
        ...state,
        imgUrl: action.payload.file.url
      }
    }
    default:
      return state
  }
}

export default reducer
